<template>
  <div class="height-full">
    <app-header title="Billing"/>
    <b-card no-body>
      <div class="row ">
        
        <div class="col-md-12">

          <b-card style="padding-top: 2%; padding-bottom: 40%">
            <spinner v-if="isLoading"></spinner>
            <div v-if="isLoading == false">
              <div v-if="subscription === null">
                <div class="description-container">
                  <b-col md="12">
                    <h2>You aren't currently subscribed to a plan.</h2>
                    <p>Subscribe on our plans page to get access to more credits.</p>
                    <b-button variant="primary" id="subscribe-now-btn" v-on:click="plans">Subscribe Now</b-button>
                  </b-col>
                </div>
              </div>
              <div v-else>
                <h3>Plan</h3>
                <p>ChatRise can send you email notifications when you have new messages available.</p>
                <br />
                <h3>Credit Card</h3>
                <p>Currently using your card that ends in <span class="font-weight-bold">{{paymentMethod.card.last4}}</span> that expires on <span class="font-weight-bold">{{expirationString()}}</span>.</p>
                <br />
                <p><a href="#">Cancel Subscription</a></p>
              </div>
            </div>
          </b-card>
        </div>
      </div>      
    </b-card>
  </div>
</template>

<script>
  import AmplifyStore from '../store/store'
  import axios from 'axios'
  import Spinner from './common/Spinner'

  import Constants from '../Constants'
  export default {
    name: 'Billing',
    components: {
      Spinner
    },
    data: () => {
      const that = this;
      return {
        isLoading: false,
        subscription: null,
        paymentMethod: null    
      };
    },
    methods: {
      toggleAccordion: function (el) {
        this[el] = !this[el]
      },
      switchChanged: function(el) {
        console.log(el)
        if (el == true) {
          this.setNotificationPrefs('default')
        } else {
          this.setNotificationPrefs('none')
        }
      },
      selectChanged: function(el) {
        this.prefs = el
        this.setNotificationPrefs(this.prefs)
      },
      setNotificationPrefs: function(prefs) {
        // none, default, hourly, four_hours, Daily
        this.prefs = prefs
        this.updateNotificationPrefs(this.prefs)
      },
      getSubscription() {
        this.isLoading = true
        axios.get(Constants.API_URL + '/account/subscriptions')
          .then(response => {
            console.log(response)
            if (response.data.subscription.id !== undefined) {
              this.subscription = response.data.subscription
              this.paymentMethod = response.data.payment_method
            }
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      getNotificationPrefs: function() {
        this.isLoading = true
        axios.get(Constants.API_URL + "/me")
          .then((response) => {
            this.prefs = response.data.Items[0].emailNotificationPrefs
            console.log("PREFS:")
            console.log(this.prefs)
            this.checked = this.prefs != 'none'
            this.selected = this.prefs
          }).catch((err) => {
            console.log(err)
          }).then(() => {
            this.isLoading = false
          }) 
      },
      updateNotificationPrefs: function(prefs) {
        this.selected = this.prefs
        axios.put(Constants.API_URL + "/me?emailNotificationPrefs=" + prefs)
          .then((response) => {
            console.log(response)
          })
      },
      plans() {
        this.$router.push('/plans')
      },
      expirationString() {
        const card = this.paymentMethod.card
        return card.exp_month + '/' + card.exp_year
      }
    },
    mounted() {
      this.getSubscription()
      // this.getNotificationPrefs()
    }
  }
</script>

<style scoped>
.subtitle {
  margin-top: 8px;
}

.subtitle i {
  font-size: 14px;
}

.description-container {
  text-align: center;
  padding: 40px;
  padding-top: 80px;
}

.description-container p {
  font-size: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/Billing.vue